import type { FaireProductEntity } from "../../entity_types/product";

export const p_ueyf4dqe4u: FaireProductEntity = {
  token: "p_ueyf4dqe4u",
  type: "product",
  name: 'Grateful Dead - Dancing Bears Flat Magnet (2.5" x 3.5")',
  brandToken: "b_j6d3pdgeyx",
  brandName: "Great Stuff Novelties (GSN) by NMR Brands",
  imageUrl:
    "https://cdn.faire.com/fastly/9d1b882968c8228062b7153139ae5acbe632099f4c4796dc44106644bea11c7e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cfcd608ca327463586ab3a7d83a94631c298e6c3b63b7d98aabbbf6a8bd66932.jpeg",
  ],
  priceDollars: 3.1,
  description:
    'Grateful Dead - Dancing Bears Flat Magnet (2.5" x 3.5")\n\nELEVATE YOUR FANDOM with the unparalleled collection of high quality rectangular flat magnets measuring 2.5 by 3.5 inches, crafted exclusively for the most dedicated enthusiasts and fans.\n\nNOT JUST A FRIDGE MAGNET: Transform your whiteboard, game room, collection case, or your fridge into an epic hub of excitement. These captivating magnets will make you the envy of your friends and family as you bring the action home in style.\n\nLOOKING FOR GRATEFUL DEAD GIFTS? This incredible decorative magnet is the perfect gift idea for fans of all ages.\n\n100% OFFICIALLY LICENSED MERCHANDISE: All our magnets are designed by AQUARIUS, officially licensed, and 100% authentic. They\'re the perfect piece of collectible memorabilia to add to your collection',
  tags: [],
  msrpDollars: 6.88,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:12.302Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
